import { Injectable } from '@angular/core';
import { nextTick } from 'node:process';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CartService {

  private cart: any = new BehaviorSubject<any>(this.getCartDataFromLocalStorage()); 
  private klarnaS = new BehaviorSubject<string>('PENDING');

  cart$ = this.cart.asObservable();
  klarnaStatus$ = this.klarnaS.asObservable();


  deliveryOptions = [
    { code: 'STANDARD', name: 'Standard Delivery' },
    { code: 'EXPRESS', name: 'Express Delivery' },
    { code: 'NEXTDAY', name: 'Next Day Delivery' },
    { code: 'COLLECTION', name: 'Collection' },
  ];

  paymentMethods = [
    {
      code: 'STRIPE',
      name: 'Pay with card',
      images: ['assets/images/stripe.png'],
    },
    {code : "KLARNA3", name:"3 interest free installments" , images: ["assets/images/klarna.svg"]},
    {code : "KLARNA30", name: "Pay in 30 days" , images: ["assets/images/klarna.svg"]},
    {code : "KLARNA", name: "Pay now" , images: ["assets/images/klarna.svg"]},
    {
      code: 'BANK_TRANSFER',
      name: 'Bank Transfer',
      images: ['assets/images/bank-transfer.png'],
    },
  ];

  checkoutSteps = [
    {
      title: 'Review your order summary',
      isCompleted: false,
    },
    {
      title: 'Enter your billing details',
      isCompleted: false,
    },
    {
      title: 'Pay & Submit your order!',
      isCompleted: false,
    },
  ];

  constructor() { }

  getCartDataFromLocalStorage() {
    const cart = localStorage.getItem('cartB');
    return cart ? JSON.parse(cart) :  {
      items: [],
      total: 0,
      totalFormatted: '',
      weight: 0
    };
  }

  setCart(globalCart: any): void {
    this.cart.next(globalCart);
    localStorage.setItem('cartB', JSON.stringify(globalCart));
  }

  setKlarnaStatus(status: string) {
    this.klarnaS.next(status);
  }

  resetCart() {
    const emptyCart = {
      items: [],
      total: 0,
      totalFormatted: '',
      weight: 0
    };
    this.cart.next(emptyCart);
    localStorage.setItem('cartB', JSON.stringify(emptyCart));
  }

  getCheckoutPageData() {
    return {
      deliveryOptions: this.deliveryOptions,
      checkoutSteps: this.checkoutSteps,
      paymentMethods: this.paymentMethods,
    };
  }

  addSingleItemToCart(
    title: string,
    sku: string,
    price: number,
    quantity: number,
    image?: string
  ) {
    const itemPrice = price * quantity;
    const isExists = this.cart.items.find((cItem: any) => cItem.sku === sku);
    if (isExists) {
      isExists.quantity += quantity;
    } else {
      this.cart.items.push({
        name: title,
        sku: sku,
        price: price,
        quantity: quantity,
        image: image ? image : 'https://placehold.co/800x500',
      });
    }
    this.cart.total += itemPrice;
  }


}
